export const Footer = () => (
    <footer className="relative border-t border-rule px-6 py-20 md:px-10">
        <div className="mx-auto flex max-w-4xl flex-col items-center gap-5 text-center">
            <span className="font-deva text-6xl text-wax">पत्र</span>
            <p className="font-serif text-lg text-ink/80">patr.ai — named after the Hindi word for letter</p>
            <p className="font-serif text-xl italic text-ink">Made with AI. Named after paper.</p>
            <div className="mt-2 flex items-center gap-3 font-sans text-xs tracking-[0.28em] uppercase text-sepia">
                <a
                    data-testid="footer-mailto"
                    href="mailto:vinay@patr.ai"
                    className="text-wax transition-opacity hover:opacity-70"
                >
                    vinay@patr.ai
                </a>
                <span className="h-1 w-1 rounded-full bg-rule" />
                <span>© 2026 Vinay Malviya</span>
            </div>
        </div>
    </footer>
);
